import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, Divider, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";

import Icon_MST_2 from "../../assets/icons/Icon_MST_2.svg";
import icon_address from "../../assets/icons/icon_address.svg";
import Icon_mail from "../../assets/icons/Icon_mail.svg";
import logoDefault from "../../assets/icons/logo_default.svg";
import { getInforByProviderId } from "../../extra/utils";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-container": {
      alignItems: "flex-start !important",
    },
    "& .MuiDialog-paper": {
      marginTop: "12vh !important",
      borderRadius: 16,
      margin: 16,
      padding: "8px 0",
      backgroundColor: "#F0F2F5",
      [theme.breakpoints.down("sm")]: {
        minWidth: "92vw",
        margin: 12,
      },
    },
  },
  dialogMobile: {
    "& .MuiDialog-container": {
      alignItems: "flex-end !important",
    },
    "& .MuiDialog-paper": {
      margin: "0 !important",
      width: "100% !important",
      maxWidth: "100% !important",
      height: "70vh !important",
      borderRadius: "16px 16px 0 0 !important",
      padding: "8px 0",
      backgroundColor: "#F0F2F5 !important",
    },
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px 12px 20px",
    backgroundColor: "#F0F2F5",
  },
  titleText: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#343A40",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  closeBtn: {
    color: "#64748B",
    padding: 6,
    background: "#fff",
    "&:hover": {
      background: "#E2E8F0",
    },
  },
  content: {
    padding: "20px 20px 24px 20px",
    backgroundColor: "#F0F2F5",
  },
  companyHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "24px",
  },
  logoBox: {
    width: "80px",
    height: "50px",
    border: "0.5px solid #D2D2D2",
    borderRadius: "8px",
    padding: "4px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
    flexShrink: 0,
  },
  logoImg: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    minWidth: '45px'
  },
  companyName: {
    marginLeft: "16px",
    fontSize: "20px",
    fontWeight: 700,
    // color: "#1A427D",
    lineHeight: "1.4",
    // [theme.breakpoints.down("sm")]: {
    //   fontSize: "18px",
    // },
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    margin: "18px 0",
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  icon: {
    width: "20px",
    height: "20px",
    marginRight: "8px",
  },
  labelText: {
    color: "#646D69",
    fontSize: "14px",
    fontWeight: 500,
  },
  valueText: {
    color: "#343A40",
    fontSize: "14px",
    fontWeight: 600,
    textAlign: "right",
    maxWidth: "65%",
    lineHeight: "1.4",
  },
}));

function InforCompany({ state, dispatch, isMobile }) {
  const classes = useStyles();

  const { openMDInfoCompany, detailData } = state;

  const { providerLogo, providerId } = detailData;
  const infor = getInforByProviderId(providerId);

  return (
    <Dialog
      open={openMDInfoCompany}
      onClose={() => dispatch("closeMDInfoCompany")}
      className={isMobile ? classes.dialogMobile : classes.dialog}
    >
      <div className={classes.titleContainer}>
        <span className={classes.titleText}>Thông tin công ty bảo hiểm</span>
        <IconButton onClick={() => dispatch("closeMDInfoCompany")} className={classes.closeBtn} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <Divider />
      <DialogContent className={classes.content}>
        <div className={classes.companyHeader}>
          <div className={classes.logoBox}>
            <img
              src={providerLogo || logoDefault}
              alt="Company Logo"
              className={classes.logoImg}
            />
          </div>
          <div className={classes.companyName}>
            {infor.name || detailData?.productTitle || '-'}
          </div>
        </div>

        <div className={classes.infoRow}>
          <div className={classes.labelContainer}>
            <img src={Icon_MST_2} alt="mst" className={classes.icon} />
            <span className={classes.labelText}>Mã số thuế:</span>
          </div>
          <span className={classes.valueText}>{infor.taxCode || '-'}</span>
        </div>

        <div className={classes.infoRow}>
          <div className={classes.labelContainer}>
            <img src={icon_address} alt="address" className={classes.icon} />
            <span className={classes.labelText}>Địa chỉ:</span>
          </div>
          <span className={classes.valueText}>
            {infor.address || "-"}
          </span>
        </div>

        <div className={classes.infoRow}>
          <div className={classes.labelContainer}>
            <img src={Icon_mail} alt="email" className={classes.icon} />
            <span className={classes.labelText}>Email:</span>
          </div>
          <span className={classes.valueText}>{infor.email || '-'}</span>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default InforCompany;
